export const COOKIES = {
  ACCESS_TOKEN: 'xsolla_metaframe_token',
};

export const API_URL = {
  INVENTORY_COLLECTIONS_URL: '/v1/inventory/collections',
  INVENTORY_SINGLE_DROPS_URL: '/v1/inventory/single_drops',
};

export const BASE_PATH_PREFIX = '/rewards';

const INDEX_ROUTE = '/';

export const ROUTE = {
  INDEX: INDEX_ROUTE,
  INVENTORY_ROUTE: '/inventory',
  COLLECTION_ROUTE: '/inventory/collections',
  DROP_ROUTE: '/inventory/drops',
  PRIME_GAMING_LINKING_ROUTE: '/prime-gaming/linking',
  PRIME_GAMING_REDIRECT_ROUTE: '/prime-gaming/redirect',
};
